import { http } from 'src/core/services/http';

export const getCustomerTypes = () => http.get('common/systemTypes/customerTypes').then(response => response.data);
